"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var linking_native_exports = {};
__export(linking_native_exports, {
  addEventListener: () => addEventListener,
  getDefaultLinkingPrefixes: () => getDefaultLinkingPrefixes,
  getInitialURL: () => getInitialURL,
  getPathFromState: () => import_getPathFromState.getPathFromState,
  getRootURL: () => getRootURL,
  getStateFromPath: () => import_getStateFromPath.getStateFromPath
});
module.exports = __toCommonJS(linking_native_exports);
var import_react_native = require("react-native");
var import_getPathFromState = require("../fork/getPathFromState");
var import_getStateFromPath = require("../fork/getStateFromPath");
function getInitialURL() {
  return Promise.race([
    (async function() {
      var url = await import_react_native.Linking.getInitialURL();
      return url !== null && url !== void 0 ? url : getRootURL();
    })(),
    new Promise(function(resolve) {
      return (
        // Timeout in 150ms if `getInitialState` doesn't resolve
        // Workaround for https://github.com/facebook/react-native/issues/25675
        setTimeout(function() {
          return resolve(getRootURL());
        }, 150)
      );
    })
  ]);
}
function getRootURL() {
  return "/";
}
function getDefaultLinkingPrefixes() {
  return [];
}
function addEventListener(listener) {
  var subscription = import_react_native.Linking.addEventListener("url", function(param) {
    var { url } = param;
    return listener(url);
  });
  return function() {
    var _subscription_remove;
    subscription === null || subscription === void 0 ? void 0 : (_subscription_remove = subscription.remove) === null || _subscription_remove === void 0 ? void 0 : _subscription_remove.call(subscription);
  };
}
//# sourceMappingURL=linking.native.js.map
